<template>
  <div class="modal_wrap system event_popup" :class="{ on: show }">
    <div class="popup_inner">
      <div class="p_modal_wrap">
        <div class="p_top_wrap">
          <div class="p_top">
            <div class="p_top_btn_1" @click="pop_today_close">
              오늘 하루 보지 않기
            </div>
            <div class="p_top_btn_2" @click="pop_close">
              닫기
              <img
                :src="require('@/assets/front/images/i_x_pop_s.png')"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="p_modal">
          <div class="p_modal_con">
            <div class="p_slider">
              <Swiper :options="swiperOption2" ref="popupSwiper">
                <SwiperSlide v-for="(item, index) in popupImg" :key="index">
                  <div
                    @click="pop_link(item.linkId, item.linkName, item.params)"
                  >
                    <img
                      :src="require(`@/assets/front/images/popup/${item.img}`)"
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <!-- <div class="swiper-pagination-popup" slot="pagination"></div> -->
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Import Swiper styles
import 'swiper/swiper.scss';

export default {
  name: 'eventPopup',
  props: {
    show: Boolean,
    popupImg: Array,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption2: {
        // loop: true,
        // autoplay: {
        //   delay: 3000,
        // },
        // speed: 2500,
        // pagination: {
        //   el: '.swiper-pagination-popup',
        //   type: 'fraction',
        // },
      },
    };
  },
  computed: {},
  mounted() {
    // new Swiper('.swiper-container', {
    //   observer: true,
    //   observeParents: true,
    //   loop: true,
    //   pagination: {
    //     el: '.swiper-pagination-popup',
    //   },
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    //   scrollbar: {
    //     el: '.swiper-scrollbar',
    //   },
    // });
  },
  methods: {
    async pop_close() {
      this.$emit('close');
    },
    async pop_today_close() {
      this.$emit('today_close');
    },
    pop_link(id, linkName, params) {
      this.$emit('popup_link', id, linkName, params);
    },
  },
};
</script>
